'use client'

import { useQuery } from '@tanstack/react-query'

import axios from '@/_lib/axiosInstance'
import { ApiResponse, IOrderTimeSlotDetail } from '@/_types'

/**
 * Fetches rich timeslot detail (workplace, doctor, etc.) after the user picks a slot.
 *
 * @param id - Timeslot id from the cart or calendar selection.
 */
export const fetchTimeSlotDetail = async (
	id: number
): Promise<ApiResponse<IOrderTimeSlotDetail>> => {
	return axios
		.get<ApiResponse<IOrderTimeSlotDetail>>(`v1/web/ecommerce/timeslots/${id}`)
		.then(res => res.data)
}

/**
 * React Query hook for {@link fetchTimeSlotDetail}; disabled when `id` is `null` or `0`.
 *
 * @param id - Timeslot id or `null` while the selection is not committed.
 */
export const useGetTimeSlotDetail = (id: number | null) => {
	return useQuery<ApiResponse<IOrderTimeSlotDetail>>({
		queryKey: ['time-slot-detail', id],
		queryFn: () => fetchTimeSlotDetail(id as number),
		enabled: id != null && id !== 0,
		select: data => data
	})
}
